'use strict';

import * as dom from './lib/dom.js';

function followScroll() {
	const singleEl = document.querySelector('.c-single');
	const singleEpecialEl = document.querySelector('.single-special');
	const displayWidth = window.innerWidth;

	if (singleEl && displayWidth >= 1024 && !singleEpecialEl) {
		const header = document.querySelector('header');
		const headerHeight = header.offsetHeight;
		const mainContent = document.querySelector('.c-content-shield__main');
        const highlight = document.querySelector('.o-single-hightlight-wrapper');
        const highlightHeight = highlight.offsetHeight;
        const highlightWidth = highlight.offsetWidth;
		const mainContentHeight = mainContent.offsetHeight + highlightHeight;
		const mainContentWidth = mainContent.offsetWidth;

		// const bigBannerAside =  document.querySelector('.o-slot-content--big');
		// const bigBannerAsideHeight = bigBannerAside.offsetHeight;
		// const bigBannerAsideEndOffset = dom.getPosition(bigBannerAside).y + bigBannerAsideHeight + window.scrollY;
		// const bigBannerAsideStartOffset = dom.getPosition(bigBannerAside).y + window.scrollY;
		// let lastBigBannerAsideStartOffset = bigBannerAsideStartOffset;

		const aside = document.querySelector('.o-social-float:not(.o-social-float--horizontal)');
		if (!aside) {
			return;
		}
		const asideHeight = aside.offsetHeight;
		const mainContentStartOffset = dom.getPosition(highlight).y + window.scrollY;
		const mainContentEndOffset = dom.getPosition(mainContent).y + mainContentHeight + window.scrollY;
		const asideEndOffset = dom.getPosition(aside).y + asideHeight + window.scrollY;
		const asideStartOffset = dom.getPosition(aside).y + window.scrollY;
		let lastAsideStartOffset = asideStartOffset;
        
		// console.log(alsoRead);

		if (asideHeight > mainContentEndOffset - asideHeight) {
            aside.style.position = 'relative';
        } else {
            if(window.scrollY > (mainContentStartOffset - headerHeight) && window.scrollY < (mainContentEndOffset - asideHeight - 150)) {
            aside.style.position = 'fixed';
            aside.style.top = '150px';
            aside.style.right = 'auto';
               aside.style.marginLeft = highlightWidth + 18 + 'px';

            } else if (window.scrollY > (mainContentEndOffset - asideHeight - 150)) {

                   aside.style.position = 'absolute';
                aside.style.top = mainContentHeight - asideHeight + 'px';
                aside.style.right = '0px';
                   aside.style.marginLeft = '0px';
             }  else {
                 aside.style.position = 'absolute';
                   aside.style.marginLeft = 0;
                   aside.style.right = '-56px';
                   aside.style.top = '0px';
             }
        }

	}
}



export default function(){
	window.addEventListener('DOMContentLoaded', function() {
        const shareSocialTrigger = document.querySelectorAll('.js-open-social-share');
		

		dom.forEachEl(shareSocialTrigger, (el) => {
			const parent = dom.parents(el, 'o-social-float');
			console.log(parent);
			const shareSocialBtnsContent = parent.querySelector('.o-social-float__btns-content');
			const shareSocialFloatContent = parent;

			el.addEventListener('click', (e)=>{
				console.log(el);
				e.preventDefault();
				if (dom.hasClass(el, 'active')) {
					dom.removeClass(el, 'active');
					dom.removeClass(shareSocialBtnsContent, 'active');
					dom.removeClass(shareSocialFloatContent, 'active');
				} else {
					dom.addClass(el, 'active');
					dom.addClass(shareSocialBtnsContent, 'active');
					dom.addClass(shareSocialFloatContent, 'active');
				}
			})
		});

		
    });
	
	window.addEventListener('resize', function() {
        followScroll();
  	});

	window.addEventListener('scroll', function() {
	    followScroll();
	});
}
